export default {"src":"/_next/static/media/weld-mask.68588c4b.svg","height":190,"width":162,"blurWidth":0,"blurHeight":0};